import { render } from "./about-nlite.vue?vue&type=template&id=3dcf3893&scoped=true"
import script from "./about-nlite.vue?vue&type=script&lang=js"
export * from "./about-nlite.vue?vue&type=script&lang=js"

import "./about-nlite.vue?vue&type=style&index=0&id=3dcf3893&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dcf3893"]])

export default __exports__